module.exports = "\n<div class=\"bubble-section\">\n        <div width=\"700px\" height=\"80vh\" id = \"bubble_svg\"></div>\n</div>"